import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import "./result.css";

const Results = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // استرجاع التوكن من الكوكيز
  const token = Cookies.get("token");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/surveys`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        // عكس ترتيب البيانات بحيث تظهر من الأخير إلى الأول
        const reversedData = (response?.data?.data || response.data || [])
          .slice()
          .reverse();
        setData(reversedData);
      } catch (error) {
        toast.error("حدث خطأ أثناء جلب البيانات");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  // تعريف الأعمدة بناءً على بنية الداتا القادمة من الـ API
  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Comments",
      cell: (row) => <div className="custom-comment">{row.comments}</div>,
      sortable: true,
    },
    {
      name: "Answered By",
      selector: (row) => row.answered_by || "N/A",
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
    {
      name: "Answers",
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {row.answers &&
            row.answers.map((item, index) => (
              <div key={index}>
                <strong>Q{item.survey_question_id}:</strong> {item.answer}
              </div>
            ))}
        </div>
      ),
    },
  ];

  return (
    <div className="p-4 max-w-[calc(100vw-100px)] flex flex-col gap-4">
      {loading ? (
        <p>جاري التحميل...</p>
      ) : (
        <DataTable
          title="Survey Results"
          columns={columns}
          data={data}
          pagination
          highlightOnHover
        />
      )}
    </div>
  );
};

export default Results;
